import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.80054 2.40926C5.29054 0.90119 7.42407 0.901191 7.91407 2.40926C8.26708 3.49572 9.27952 4.2313 10.4219 4.2313C12.0076 4.2313 12.6669 6.26041 11.384 7.19245C10.4598 7.86391 10.0731 9.05411 10.4261 10.1406C10.9161 11.6486 9.19007 12.9027 7.90722 11.9707C6.98303 11.2992 5.73158 11.2992 4.80739 11.9707C3.52454 12.9027 1.79848 11.6486 2.28849 10.1406C2.6415 9.05411 2.25478 7.86391 1.33058 7.19245C0.047739 6.26041 0.707034 4.2313 2.29272 4.2313C3.43508 4.2313 4.44753 3.49572 4.80054 2.40926Z",
      fill: "#56647D",
      stroke: "white"
    }, null, -1)
  ])))
}
export default { render: render }